import { A } from "@solidjs/router";
import slugify from "slugify";
import { Component, Show } from "solid-js";
import { RawHtml } from "./raw-html";
import { Img } from "./universal/image";
import { ContestArtwork } from "../Types";

type DisplayArtworkProps ={
    isBest: boolean;
    name: string;
    prizeAmount?: number;
    artwork: ContestArtwork;
}

export const DisplayArtwork : Component<DisplayArtworkProps> = (props) => {
    const artwork = props.artwork
    const artist = artwork.FirstName + " " + artwork.LastName;
    const artistUrl = `/artist/${slugify(artist)}/${artwork.ContestEntrantId}`;
    const artworkUrl =`/artwork/${slugify(artist)}/${slugify(artwork.Title)}/${artwork.Id}`;
    const maxWidth = 700;
    return (
        <>
            <div class="grid-item dual" style={{ "max-width": `${maxWidth}px` }}>
                <div style="position:relative;">
                    <div>
                        <A href={artworkUrl}>
                            <Img class="no-clicky-for-you"
                                src={artwork.PrimaryImage.URL}
                                maxWidth={maxWidth} naturalWidth={artwork.PrimaryImage.Width} naturalHeight={artwork.PrimaryImage.Height}
                            />
                        </A>
                    </div>
                </div>
                <div class="didactic">
                    <Show when={props.isBest && props.prizeAmount}>
                        <h3 class="purchase-price">
                            ${props.prizeAmount}
                        </h3>
                    </Show>
                    <h3 class="award">
                        {props.isBest ? "Winner" : "Runner Up"}
                    </h3>
                    <h3>
                        <A href={artistUrl}>
                            {artist}
                        </A>
                    </h3>
                    <h4>
                        <A href={artworkUrl}>
                            <RawHtml value={artwork.Title} />
                        </A>
                    </h4>
                    <Show when={artwork.Year}>
                        <p>
                            {artwork.Year}
                        </p>
                    </Show>
                    <p>
                        {artwork.Medium}
                    </p>
                    <Show when={artwork.Measurements}>
                        <RawHtml value={artwork.Measurements} />
                    </Show>
                </div>
            </div>
        </>
    )
}
